<template>
  <b-form-group :class="formGroupClass">
    <validation-provider
      :name="validationLabel ? validationLabel : label.toLowerCase()"
      :rules="rules"
      v-slot="validationContext"
    >
      <label :for="`label-${label || validationLabel}`">
        <span v-html="computedLabel" />
        <slot name="labelMessage" />
      </label>
      <b-form-file
        :state="getValidationState(validationContext)"
        v-model="computedInputData"
        :readonly="readonly"
        :placeholder="computedPlaceholder"
        :accept="computedMimeTypes"
        multiple
        class="file-input-custom"
        plain
      >
      </b-form-file>
      <slot name="uploadedFiles"></slot>
      <div class="error-text">
        <span>{{
          validationContext.errors[0]
            ? validationContext.errors[0]
            : apiErrors && Object.keys(apiErrors).length
            ? apiErrors[apiErrorKey][0]
            : ""
        }}</span>
      </div>
    </validation-provider>
  </b-form-group>
</template>
<script>
import { ValidationProvider } from "vee-validate";
export default {
  props: {
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Object,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
    },
    vmodel: {
      required: true,
      default: null,
    },
    formGroupClass: {
      type: String,
      required: false,
    },
    fileClass: {
      type: String,
      required: false,
    },
    acceptMimeTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    validationLabel: {
      required: false,
    },
    apiErrors: {
      // Object with server side error flags
      required: false,
      default: () => {},
    },
    apiErrorKey: {
      // key pointing to particular entry in apiError Object
      required: false,
      default: "",
    },
  },
  components: {
    ValidationProvider,
  },
  data: () => {
    return {
      file: [],
    };
  },
  computed: {
    computedMimeTypes() {
      return this.acceptMimeTypes.toString();
    },
    computedPlaceholder() {
      if (this.placeholder == "") {
        return `No File Choosen`;
      }
      return this.placeholder;
    },
    computedLabel() {
      if (this.rules && this.rules.required) {
        return this.label + "<span class='input-required'> * </span>";
      }
      return this.label;
    },
    computedInputData: {
      get: function () {
        return this.vmodel;
      },
      set: function (files) {
        // let file = this.file;
        this.$emit("update:vmodel", files ? files : []);
      },
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
<style>
.file-input-custom {
  z-index: -5 !important;
}
.file-input-custom:before {
  content: "Choose Files";
  display: inline-block;
  background: #03c3ec;
  border-radius: 3px;
  padding: 8px 30px;
  outline: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  cursor: pointer;
  font-size: 14px;
  color: #fff;
  z-index: 1 !important;
}
.file-input-custom::-webkit-file-upload-button {
  visibility: hidden;
  margin-left: -80px;
}
</style>